import { Route } from '@angular/router';
import { authGuard } from '../auth/guards/auth.guard';
import { HomePage } from '../portal/home-page/home-page';

export const appRoutes: Route[] = [
  { path: '', component: HomePage, canActivate: [authGuard] },
  {
    path: 'auth/callback',
    redirectTo: '',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
